/**
 * Whether a journey `documents` slot counts as uploaded for UI (pending bar, modals).
 * Supports local File, persisted __fileMeta, and Stage 9 API shape:
 * `{ uploaded: true, fileName: "..." }` (often inside JSON `documentsUploaded`).
 */
export function isProposalDocumentSlotFilled(val) {
  if (val == null || val === false) return false;
  if (typeof val === "object") {
    if (val.__fileMeta) return true;
    if (typeof File !== "undefined" && val instanceof File) return true;
    if (
      val.uploaded === true ||
      val.uploaded === "true" ||
      String(val.uploaded).toLowerCase() === "y"
    ) {
      return true;
    }
  }
  return Boolean(val);
}
